module.exports = __webpack_public_path__ + "static/img/catch.8758f1cf.webp";